export default {
  'consolidatedReportStock.form.reportType.analytical': 'Analítico',
  'consolidatedReportStock.form.reportType.synthetic': 'Sintético',

  'consolidatedReportStock.form.checkbox.parts': 'Peças',
  'consolidatedReportStock.form.checkbox.consumable': 'Insumos',
  'consolidatedReportStock.form.checkbox.hideInventoryMovementAndStockCorrection':
    'Ocultar Movimentação de Inventário/Correção de Estoque?',
  'consolidatedReportStock.form.checkbox.hideInactiveProductsInTheRegister':
    'Ocultar Produtos Inativos no Cadastro',
  'consolidatedReportStock.form.checkbox.displayNonMovingParts':
    'Exibir Peças sem Movimentação?',

  'consolidatedReportStock.form.filterBy': 'Filtrar por',
  'consolidatedReportStock.form.filterBy.manufacturingCode':
    'Código de Fabricante',
  'consolidatedReportStock.form.filterBy.internalCode': 'Código Interno',
  'consolidatedReportStock.form.filterBy.barCode': 'Código de Barras',
  'consolidatedReportStock.form.filterBy.description': 'Descrição',
  'consolidatedReportStock.form.filterBy.manufacturer': 'Fabricante',
  'consolidatedReportStock.form.filterBy.group': 'Grupo',
  'consolidatedReportStock.form.filterBy.subGroup': 'Subgrupo',

  'consolidatedReportStock.form.filterByFrom': 'De:',
  'consolidatedReportStock.form.filterByTo': 'Até:',
  'consolidatedReportStock.form.group': 'Grupo',
  'consolidatedReportStock.form.subGroup': 'Subgrupo',
};
